import React from "react";
import Home from "./components/Home";
import { LocationProvider } from "./context/Geolocation";
import { BannerProvider } from "./context/BannerContext";
import { LanguageProvider } from "@a365/core";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/i18n";
import { LoaderProvider } from "./core/Loader";

// Importación de estilos (orden importante para la cascada CSS)
import "./assets/css/style.css"; // Este archivo genera tailwind-output.css
import "./assets/main.css"; // Importar estilos principales si existen

// Incluir estilos críticos directamente para mejorar LCP
const CriticalStyles = () => (
  <style
    dangerouslySetInnerHTML={{
      __html: `
      /* Estilos básicos para Slick Carousel */
      .slick-slider {
        position: relative;
        display: block;
        box-sizing: border-box;
        user-select: none;
        touch-action: pan-y;
      }
      .slick-list {
        position: relative;
        display: block;
        overflow: hidden;
        margin: 0;
        padding: 0;
      }
      .slick-track {
        position: relative;
        top: 0;
        left: 0;
        display: flex;
        margin-left: auto;
        margin-right: auto;
      }
      .slick-slide {
        display: none;
        float: left;
        height: 100%;
        min-height: 1px;
      }
      .slick-slide img {
        display: block;
      }
      .slick-initialized .slick-slide {
        display: block;
      }
      .slick-dots {
        position: absolute;
        bottom: -25px;
        display: block;
        width: 100%;
        padding: 0;
        margin: 0;
        list-style: none;
        text-align: center;
      }
      .slick-dots li {
        position: relative;
        display: inline-block;
        margin: 0 5px;
        padding: 0;
        cursor: pointer;
      }
      .slick-dots li button {
        font-size: 0;
        line-height: 0;
        display: block;
        width: 10px;
        height: 10px;
        padding: 5px;
        cursor: pointer;
        color: transparent;
        border: 0;
        outline: none;
        background: #ccc;
        border-radius: 50%;
      }
      .slick-dots li.slick-active button {
        background: #333;
      }
      .slick-prev, .slick-next {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        cursor: pointer;
        z-index: 1;
        background: rgba(255, 255, 255, 0.5);
        border: none;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
      }
      .slick-prev {
        left: 10px;
      }
      .slick-next {
        right: 10px;
      }
    `,
    }}
  />
);

export default function Root(props) {
  return (
    <>
      <CriticalStyles />
      <I18nextProvider i18n={i18n}>
        <LocationProvider>
          <BannerProvider>
            <LanguageProvider i18nInstance={i18n}>
              <LoaderProvider>
                <div className="home-wrapper">
                  <Home />
                </div>
              </LoaderProvider>
            </LanguageProvider>
          </BannerProvider>
        </LocationProvider>
      </I18nextProvider>
    </>
  );
}
